import * as React from "react";

function ChevronLeft(props) {
  return <svg viewBox="0 0 24 24" fill="none" {...props}><path d="M15 5l-7 7 7 7" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" /></svg>;
}

export default ChevronLeft;